module.exports = __webpack_public_path__ + "static/img/one_right01.c90713a.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/one_right01.png
// module id = WQNs
// module chunks = 3